var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "info-box" }, [
    _c("div", { class: "info-box__abrv " + _vm.colorClass }, [
      _c("span", [_vm._v(_vm._s(_vm.title))])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info-box__content" }, [
      _c("span", { staticClass: "info-box__title" }, [
        _vm._v(_vm._s(_vm.descripcion))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info-box__values" }, [
        _c(
          "div",
          { staticClass: "info-box__value" },
          [
            _c("span", [_vm._v(_vm._s(_vm.prefix))]),
            _vm._v(" "),
            _c("ICountUp", {
              attrs: {
                startVal: _vm.startVal,
                endVal: _vm.getTotal(_vm.totalVal),
                decimals: _vm.decimals,
                duration: _vm.duration,
                options: _vm.options
              }
            }),
            _vm._v(" "),
            !_vm.onlyInteger ? _c("span", [_vm._v(".")]) : _vm._e(),
            _vm._v(" "),
            !_vm.onlyInteger && _vm.getTotalDecimals(_vm.totalVal) < 10
              ? _c("span", [_vm._v("0")])
              : _vm._e(),
            _vm._v(" "),
            !_vm.onlyInteger
              ? _c("ICountUp", {
                  attrs: {
                    startVal: _vm.startVal,
                    endVal: _vm.getTotalDecimals(_vm.totalVal),
                    decimals: _vm.decimals,
                    duration: _vm.duration,
                    options: _vm.options
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.enableQuantity,
                expression: "enableQuantity"
              }
            ],
            staticClass: "info-box__quantity"
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.quantityText))]),
            _vm._v(" "),
            _c("ICountUp", {
              attrs: {
                startVal: _vm.startVal,
                endVal: parseInt(_vm.quantity),
                decimals: _vm.decimals,
                duration: _vm.duration,
                options: _vm.options
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showButton,
            expression: "showButton"
          }
        ],
        staticClass: "info-box__button",
        on: { click: _vm.showCharts }
      },
      [
        _c(
          "button",
          { staticClass: "btn-light btn--text", attrs: { type: "button" } },
          [
            _c("i", {
              staticClass: "fa",
              class: _vm.displayAnimation ? "fa-close" : "fa-bar-chart"
            })
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5787a043", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5787a043","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/InfoBox.vue
// module id = 303
// module chunks = 0